<template>
  <div>
    <BCard class="mb-0">
      <div v-if="!loader">
        <BRow class="d-flex justify-content-between" style="padding: 0 15px">
          <BTabs v-model="tabIndex" content-class="pt-1">
            <BTab
                v-for="(currency, index) in currencies"
                :key="currency.id"
                @click="changeTab(currency.id, currency.name, index)"
            >
              <template #title>
                <span>{{ currency.name }}</span>
              </template>
            </BTab>
          </BTabs>
          <div>
            <span v-if="isBuyerDashboard">
              {{ $t('investment_profile_heading') }}
              <span v-if="data.autoInvestmentStatus" class="text-success"> {{ $t('active') }}</span>
              <span v-else class="text-danger"> {{ $t('inactive') }}</span>
            </span>
          </div>
        </BRow>
        <BRow v-if="isBuyerDashboard" class=" ml-auto justify-center">
          <BCard
              class="col-xl-5 col-lg-6 col-md-6 col-xs-12 m-1"
              no-body
              style="border: 1px solid lightgray"
          >
            <BCardBody class="row justify-content-between align-items-start">
              <BCol md="6" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                <div class="truncate col-md-12">
                  <h6>{{ $t("saldo_balance") }}</h6>
                  <h2
                      class="mb-25 font-weight-bolder"
                      style="color:#1B4332 ;"
                  >
                    <span v-if="data.openBalance">
                      {{ amountFormat(data.openBalance, currency.name) }}
                    </span>
                    <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                  </h2>
                </div>
              </BCol>
              <!-- Purchased Invoices -->
              <BCol md="6" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                <BMedia no-body>
                  <BMediaAside class="mr-2">
                    <BAvatar size="48" variant="light-primary">
                      <FeatherIcon size="24" icon="FileTextIcon"/>
                    </BAvatar>
                  </BMediaAside>

                  <BMediaBody class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      <span v-if="data.invoicesPurchased">{{ data.invoicesPurchased }}</span>
                      <span v-else>0</span>
                    </h4>
                    <BCardText class="font-small-3 mb-0">
                      {{ $t("purchased_invoices_fractions") }}
                    </BCardText>
                  </BMediaBody>
                </BMedia>
              </BCol>
              <!-- Invested Amount -->
              <BCol md="6" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                <div class="truncate col-md-12">
                  <h6>{{ $t("allocated_amount") }}</h6>
                  <h2 class="mb-25 font-weight-bolder">
                    <span v-if="data.allocated">
                      {{ amountFormat(data.allocated, currency.name) }}
                    </span>
                    <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                  </h2>
                </div>
              </BCol>
              <!-- Settled Invoices -->
              <BCol md="3" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                <BMedia no-body>
                  <BMediaAside class="mr-2">
                    <BAvatar size="48" variant="light-primary">
                      <FeatherIcon size="24" icon="FileTextIcon" color="#0a9104"/>
                    </BAvatar>
                  </BMediaAside>
                  <BMediaBody class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      <span v-if="data.settledInvoices">{{ data.settledInvoices }}</span>
                      <span v-else>0</span>
                    </h4>
                    <BCardText class="font-small-3 mb-0">
                      {{ $t("settled_invoice") }}
                    </BCardText>
                  </BMediaBody>
                </BMedia>
              </BCol>
            </BCardBody>
          </BCard>
          <BCard
              no-body
              class="card-statistics col-md-6 col-xs-12 m-1"
              style="border: 1px solid lightgray"
          >
            <BCardBody class="statistics-body">
              <BRow>
                <!-- Purchased Volume-->
                <BCol md="3" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="48" variant="light-success">
                        <FeatherIcon size="24" icon="DollarSignIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.amountPurchased">
                          {{ amountFormat(data.amountPurchased, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("purchased_volume") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <!-- Net Return -->
                <BCol md="3" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                  <BMedia no-body>
                    <BMediaAside>
                      <BAvatar size="48" variant="light-success" class="relative">
                        <div style="position: absolute;left: 8px;">
                          <BAvatar size="20" style="background-color: #fcd34d; color: #fff;">
                            <FeatherIcon class="absolute top-[2px] left-[6px] text-gray-700" size="15" icon="DollarSignIcon"/>
                          </BAvatar>
                        </div>

                        <div style="position: absolute;left: 20px;">
                          <BAvatar size="20" style="background-color: #fcd34d; color: #fff;">
                            <FeatherIcon class="absolute top-[2px] left-[6px] text-gray-700" size="15" icon="DollarSignIcon"/>
                          </BAvatar>
                        </div>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.totalNetReturn">
                          {{ amountFormat(data.totalNetReturn, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("net_return_v_2") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <!-- Outstanding Expected Net Return-->
                <BCol md="3" sm="6" class="mb-2 mb-md-0 col-md-6 mt-1 mb-1">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="48" variant="light-primary">
                        <FeatherIcon size="24" icon="TrendingUpIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.amountOutstanding">
                          {{ amountFormat(data.amountOutstanding, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("outstanding_expected_net_return") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>
              </BRow>
            </BCardBody>
          </BCard>
        </BRow>

        <BRow v-else-if="isPartner" class="col-12 ml-ato">
          <BCard no-body class="card-statistics col-xl-12 col-lg-12 col-md-12 col-xs-12" style="border: 1px solid lightgray">
            <BCardBody class="statistics-body">
              <BRow>
                <BCol sm="4" class="mb-2 mb-md-0  mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-success">
                        <FeatherIcon size="34" icon="DollarSignIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.openBalance">
                          {{ amountFormat(data.openBalance, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00'000.00", currency.name) }}</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("saldo_balance") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <BCol md="4" sm="4" class="mb-2 mb-md-0 mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-primary">
                        <FeatherIcon size="34" icon="UsersIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.amountOutstanding !== undefined">
                          {{ balance.amountOutstanding }}
                        </span>
                        <span v-else>0</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("referred_sellers") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <BCol sm="4" class="mb-2 mb-md-0 mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-primary">
                        <FeatherIcon size="34" icon="UsersIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.totalNetReturn !== undefined">
                          {{ balance.totalNetReturn }}
                        </span>
                        <span v-else>0</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("referred_buyers") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>
              </BRow>
            </BCardBody>
          </BCard>
        </BRow>

        <BRow v-else-if="isSeller" class="col-12 ml-ato">
          <BCard no-body class="card-statistics col-xl-12 col-lg-12 col-md-12 col-xs-12" style="border: 1px solid lightgray">
            <BCardBody class="statistics-body">
              <BRow>
                <BCol md="4" sm="4" class="mb-2 mb-md-0  mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-success">
                        <FeatherIcon size="34" icon="DollarSignIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.openBalance">
                          {{ amountFormat(data.openBalance, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("liquidity_received") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <BCol md="4" sm="4" class="mb-2 mb-md-0 col-md-4 mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-primary">
                        <FeatherIcon size="34" icon="TrendingUpIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.invoicesPurchased">{{ balance.invoicesPurchased }}</span>
                        <span v-else>0</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("invoices_sold") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>

                <BCol sm="4" class="mb-2 mb-md-0 mt-1 mb-2">
                  <BMedia no-body>
                    <BMediaAside class="mr-2">
                      <BAvatar size="58" variant="light-success">
                        <FeatherIcon size="34" icon="DollarSignIcon"/>
                      </BAvatar>
                    </BMediaAside>
                    <BMediaBody class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.amountOutstanding">
                          {{ amountFormat(balance.amountOutstanding, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h3>
                      <BCardText class="font-small-3 mb-0">
                        {{ $t("amount_outstanding") }}
                      </BCardText>
                    </BMediaBody>
                  </BMedia>
                </BCol>
              </BRow>
            </BCardBody>
          </BCard>
        </BRow>
      </div>
      <div v-else>
        <img src="/new-loader.svg" alt="Loader">
      </div>
    </BCard>

    <BCard class="mt-2 mb-0">
      <BRow>
        <BCol sm="4" class="mb-0">
          <BTabs
              v-model="transactionTabIndex"
              class="m-0"
              nav-class="m-0"
              content-class="d-none p-0 m-0"
          >
            <BTab @click="changeTransactionTabs('transaction')">
              <template #title>
                <span>{{ $t('transaction') }}</span>
              </template>
            </BTab>
            <BTab v-if="isCompanyBuyer" @click="changeTransactionTabs('option_tab')">
              <template #title>
                <span>{{ $t('option_tab') }}</span>
              </template>
            </BTab>
          </BTabs>
        </BCol>
        <BCol sm="3">
          <BFormDatepicker
              :max="new Date()"
              v-model="startDate"
              :placeholder="$t('start_date')"
              reset-button
          />
        </BCol>
        <BCol sm="3">
          <BFormDatepicker
              :max="new Date()"
              :min="startDate || undefined"
              v-model="endDate"
              :placeholder="$t('end_date')"
              reset-button
          />
        </BCol>
        <BCol sm="2" class="d-flex align-items-center" style="padding:4px 0">
          <BButton @click="applyTransactionDateFilter" variant="primary" size="sm" class="mr-1">
            {{ $t('search') }}
          </BButton>
          <BButton @click="downloadPdfReport" variant="primary" size="sm" class="mr-1">
            <FeatherIcon size="12" icon="DownloadIcon"/>
            PDF
          </BButton>
          <BButton @click="downloadCsvReport" variant="primary" size="sm">
            <FeatherIcon size="12" icon="DownloadIcon"/>
            CSV
          </BButton>
        </BCol>
      </BRow>

      <BCol md="12" class="mb-5">
        <Table
            :url="url"
            :fields="fields"
            :payload="payload"
            :updateData="tableUpdateTrigger"
            :reactiveFields="true"
            :perPage="50"
        >
          <template #cell(admin_transaction_reason)="data">
            <span v-html="renderTransactionReason(data.item)"></span>
          </template>
          <template #cell(fee_hive_amount)="data">
            <span>{{ amountFormat(data.item.fee_hive_amount, data.item.currency.name) }}</span>
          </template>
          <template #cell(exchange_amount)="data">
            <span v-if="data.item.exchange_amount">
              {{amountFormat(data.item.exchange_amount, data.item.exchange_currency.name) }}
            </span>
            <span v-else>{{ amountFormat(data.item.exchange_crypto_amount, data.item.exchange_currency.name) }}</span>
          </template>
          <template #head()="scope">
            <div class="text-nowrap">
              {{ $t(scope.label) }}
            </div>
          </template>
          <template #cell(currency)="data">
            <span>{{ data.item.currency.name }}</span>
          </template>
          <template #cell(id)="data">
            <span style="width:60px;" class="badge badge-light-secondary">
              T-{{ data.value }}
            </span>
          </template>
          <template #cell(type_description)="data">
            <span v-if="isSeller && data.item.type_description === 'Purchase'">
              {{ $t("sold") }}</span>
            <span v-else-if="data.item.type_description === 'invoice_sold' || data.item.type_description === 'invoice_paid'">
              {{$t("invoice_paid")}}
            </span>
            <span v-else-if="data.item.type_description === 'ExchangeFrom' || data.item.type_description === 'ExchangeTo'">
              {{ $t("Exchange") }}
            </span>
            <span v-else>{{ $t(data.item.type_description) }}</span>
          </template>

          <template #cell(fraction)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.fraction }}%
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(fraction_amount)="data">
            <span>{{ data.item.amount | formatAmountWithoutCurrency }}</span>
          </template>
          <template #cell(fraction_discount)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.discount }}%
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(fraction_hive_fee)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.hive_fee | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(invoice_id)="data">
            <span
                v-if="data.item.invoice_id != null && data.item.invoice_id !== 0"
                style="width:55px;"
                class="badge badge-light-primary"
            >
              I-{{ data.item.invoice_id }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(fraction_net_return)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.net_return | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(created_at)="data">
            <span v-if="data.item.created_at">
              {{data.item.created_at | formatDate}}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(directions)="data">
            <FeatherIcon
                :icon="isSuccessIcon(data.item) ? 'ArrowUpCircleIcon' : 'ArrowDownCircleIcon'"
                :class="isSuccessIcon(data.item) ? 'text-success' : 'text-danger'"
            />
          </template>
          <template #cell(amount)="data">
            {{ amountFormat(data.item.amount, data.item.currency.name) }}
          </template>
          <template #cell(discount)="data">
            <span v-if="data.item.type_description !== 'Refund'">
              {{ amountFormat(data.item.discount, data.item.currency.name) }}
            </span>
            <span v-else>
              {{ amountFormat(0, data.item.currency.name) }}
            </span>
          </template>
          <template #cell(status)="data">
            <span v-if="data.value === 0" class="text-secondary">{{ $t("pending") }}</span>
            <span v-else-if="data.value === 1" class="text-success">{{ $t("approved") }}</span>
            <span v-else-if="data.value === 2" class="text-danger">{{ $t("declined") }}</span>
          </template>
          <template #cell(action)="data">
            <div style="min-width: 160px">
              <BButton variant="outline-secondary" size="sm" @click="showModal(data.item)">
                <FeatherIcon icon="SearchIcon"/>
              </BButton>
              <BButton
                  class="ml-1 web"
                  variant="outline-success"
                  size="sm"
                  @click="readInvoice(data.item)"
                  v-if="showReadInvoiceButton(data.item)"
              >
                <FeatherIcon icon="BookOpenIcon"/>
              </BButton>
              <template
                  v-if="data.item.cancel_transaction_status === 0 && data.item.type_description === 'Option' && !isSeller">
                <BButton
                    class="mt-1 mobile"
                    variant="outline-success"
                    size="sm"
                    @click="downloadPdf(data.item)"
                >
                  <FeatherIcon icon="DownloadIcon"/>
                </BButton>
                <BButton
                    class="ml-1 web"
                    variant="outline-danger"
                    size="sm"
                    @click="openCancelOptionModal(data.item)"
                >
                  <FeatherIcon icon="XIcon"/>
                </BButton>
              </template>
            </div>
          </template>
        </Table>
      </BCol>
    </BCard>

    <BModal
        id="bv-modal-example"
        size="lg"
        centered
        hide-footer
        :title="$t('details')"
    >
      <BCardText
          v-if="singleItem"
          class="text-left"
      >
        <h5>{{ $t("transaction_id") }} : {{ singleItem.id }}</h5>
        <h5>
          {{ $t("transaction_data") }} : {{ singleItem.created_at | formatDate }}
        </h5>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <h5>{{ $t("transaction") }} :</h5>
            <div>
              {{ $t("status") }} :
              <span v-if="singleItem.status === 0" class="text-secondary">{{ $t("pending") }}</span>
              <span v-else-if="singleItem.status === 1" class="text-success">{{ $t("approved") }}</span>
              <span v-else-if="singleItem.status === 2" class="text-danger">{{ $t("declined") }}</span>
            </div>
            <div>
              {{ $t("type") }} :
              <span class="text-primary">
                {{$t(singleItem.type_description) }}
              </span>
            </div>
            <div>
              {{ $t("direction") }} :
              <FeatherIcon
                  :icon="isSuccessIcon(singleItem) ? 'ArrowUpCircleIcon' : 'ArrowDownCircleIcon'"
                  :class="isSuccessIcon(singleItem) ? 'text-success' : 'text-danger'"
              />
            </div>
            <div>
              {{ $t("currency") }} : <span class="text-primary">{{ singleItem.currency.name }}</span>
            </div>
            <div v-if="isSeller || !singleItem.invoice">
              {{ $t("net_amount_sold") }}:
              <span class="text-primary">
                {{ singleItem.amount | formatAmountWithoutCurrency }}
              </span>
            </div>
          </div>
          <div v-if="singleItem.invoice" class="col-md-6">
            <h5>{{ $t("invoice_details") }} :</h5>
            <div>
              {{ $t("investment_amount") }} :
              <span v-if="singleItem.fraction" class="text-primary">
                {{ amountFormat(singleItem.fraction.amount, singleItem.currency.name) }}
              </span>
              <span v-else>
                {{ amountFormat(singleItem.amount, singleItem.currency.name) }}
              </span>
            </div>
            <div v-if="!isSeller">
              {{ $t("expected_return") }} :
              <span v-if="singleItem.fraction" class="text-primary">
                {{ amountFormat(singleItem.fraction.net_return, singleItem.currency.name) }}
              </span>
            </div>
            <div v-if="!isSeller">
              {{ singleItem.company }}
              {{ $t("roi_in_%") }} :
              <span v-if="singleItem.fraction" class="text-primary">
                ~{{ CalculationsHelper.getInvestorRoiPercentage(singleItem.invoice) }}
              </span>
            </div>
            <div>
              {{ $t("issue_date") }} :
              <span class="text-primary">
                {{ singleItem.invoice.created_at | formatDate }}</span>
            </div>
            <div>
              {{ $t("due_date") }} :
              <span class="text-primary">
                {{ singleItem.invoice.due_date | formatDate }}</span>
            </div>
            <div>
              {{ $t("payment_term") }} :
              <span class="text-primary">
                {{ singleItem.invoice.terms }}
              </span>
            </div>
            <template v-if="!isSeller">
              <div v-if="singleItem.invoice &&  singleItem.invoice.company">
                {{ $t("seller_industry") }} :
                <span class="text-primary">
                  {{ getCompanyIndustryLabel(singleItem.invoice.company) }}
                </span>
              </div>
              <div>
                {{ $t("debtor_industry") }} :
                <span class="text-primary">
                  {{ getCompanyIndustryLabel(singleItem.invoice.debtor) }}
                </span>
              </div>
            </template>
            <br><br>
          </div>
          <div v-if="singleItem.invoice_id != null && singleItem.fraction" class="col-md-6">
            <h5>{{ $t("invoice_transaction") }} :</h5>
            <div>
              {{ $t("invoice_id") }} : <span class="text-primary">I-{{ singleItem.invoice.id }}</span>
            </div>
            <div v-if="!isSeller">
              {{ $t("fraction") }} :
              <span class="text-primary">
                {{ singleItem.fraction.fraction }}%
              </span>
            </div>
            <div v-else>
              {{ $t("funding_status") }} :
              <span class="text-primary">100%</span>
            </div>
            <div>
              {{ $t("seller_id") }} :
              <span class="text-primary">
                C-{{singleItem.invoice.company.id }}
              </span>
            </div>
            <div>
              {{ $t("debtor_id") }} :
              <span class="text-primary">
                C-{{ singleItem.invoice.debtor.id }}
              </span>
            </div>
          </div>
          <div v-if="singleItem.invoice_id != null && singleItem.invoice" class="col-md-6">
            <div>
              {{ $t("invoice_id") }} :
              <span class="text-primary">I-{{ singleItem.invoice.id }}</span>
            </div>
            <div>
              {{ $t("asset_class") }} :
              <span class="text-primary"> Invoice receivable </span>
            </div>
            <div>
              {{ $t("payment_term") }} :
              <template v-if="singleItem.invoice.is_reverse !== 1">
                <span v-if="singleItem.invoice.recourse === 1" class="text-primary">
                  Silent; Recourse
                </span>
                <span v-else class="text-primary">
                  Open; Non-Recourse
                </span>
              </template>
              <template v-else>
                <span class="text-primary">
                  {{$t('silent')}} : {{$t('Reverse')}}
                </span>
              </template>
            </div>

            <div>
              {{ $t("origin_of_creditor") }} :
              <span class="text-primary"> {{ singleItem.invoice.company.country.name }} </span>
            </div>
            <div>
              {{ $t("origin_of_debtor") }} :
              <span class="text-primary"> {{ singleItem.invoice.debtor.country.name }} </span>
            </div>
          </div>
        </div>
      </BCardText>
      <hr>
    </BModal>

    <b-modal v-model="cancel_option" @ok="cancelOption">
      {{$t("cancel_share_confirmation", {fraction: remove_transaction_fraction, id: remove_transaction ? remove_transaction.invoice.id : ''}) }}
    </b-modal>

  </div>
</template>
<script>
import axios from 'axios'
import Table from '@/components/common/Table2.vue'
import fileDownload from 'js-file-download'
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat'
import CalculationsHelper from "@/helpers/calculationsHelper";

const TX_COL = {
  date: {label: 'date', align: 'start', key: 'created_at'},
  status: {label: 'status', key: 'status', customSlot: true, sortable: false},
  type: {label: 'type', align: 'start', key: 'type_description', sortable: false},
  id: {label: 'id', align: 'start', key: 'id', sortable: false},
  invoice_id: {label: 'invoice_id', align: 'start', key: 'invoice_id', sortable: false},
  directions: {label: 'directions', align: 'center', key: 'directions', sortable: false},
  currency: {label: 'currency', align: 'start', key: 'currency', sortable: false},
  amount: {label: 'amount',align: 'right', key: 'amount',sortable: false, tdClass: 'text-right', thClass: 'text-right'},
  fee: {label: 'fee', align: 'right', key: 'discount'},
  discount: {label: 'discount', align: 'right', key: 'discount'},
  fraction: {label: 'fraction', align: 'start', key: 'fraction', sortable: false},
  reason: {label: 'Reason', align: 'start', key: 'admin_transaction_reason'},
  action: {label: 'action', align: 'start', key: 'action', sortable: false},
}

const cp = (row) => ({...row})

function buildTransactionFieldsBuyer() {
  return [
    'date', 'status', 'type', 'id', 'invoice_id', 'directions', 'currency', 'amount',
    'fee', 'fraction', 'reason', 'action',
  ].map((k) => cp(TX_COL[k]))
}

function buildTransactionFieldsSeller() {
  return [
    'date', 'status', 'type', 'id', 'invoice_id', 'directions', 'currency', 'amount',
    'discount', 'reason', 'action',
  ].map((k) => cp(TX_COL[k]))
}

function buildOptionFields() {
  return [
    'date', 'status', 'type', 'id', 'directions', 'currency', 'amount',
    'fee', 'invoice_id', 'fraction', 'reason', 'action',
  ].map((k) => cp(TX_COL[k]))
}

export default {
  components: {Table},
  props: {
    transactionTableType: String,
    currencyTo: Object,
  },
  data() {
    return {
      CalculationsHelper,
      remove_transaction: null,
      remove_transaction_fraction: null,
      cancel_option: false,
      refetch_data: 0,
      payload: null,
      data: [],
      loader: false,
      fields: null,
      transaction_fields: buildTransactionFieldsBuyer(),
      transaction_fields_seller: buildTransactionFieldsSeller(),
      option_fields: buildOptionFields(),
      singleItem: null,
      balance: null,
      url: null,
      transaction_url: '/transactions',
      option_url: '/transactions/options',
      currencies: null,
      tabIndex: 0,
      transactionTabIndex: 0,
      balanceCancelTokenSource: null,
      currency: {
        name: 'CHF',
        id: 1,
      },
      startDate: null,
      endDate: null,
      appliedStartDate: null,
      appliedEndDate: null,
    }
  },
  computed: {
    authUser() {
      return this.$store.state.auth.user
    },
    isSeller() {
      return this.authUser.crole === 'seller'
    },
    isPartner() {
      return this.authUser.crole === 'partner'
    },
    isBuyerDashboard() {
      return !this.isSeller && !this.isPartner
    },
    isCompanyBuyer() {
      return this.authUser.company && this.authUser.company.role === 'buyer'
    },
    appLanguage() {
      return this.$store.state.app.language
    },

    tableUpdateTrigger() {
      const p = this.payload
      return [
        this.url,
        p && p.currency_id,
        this.refetch_data,
        p && p.start_date,
        p && p.end_date,
      ].join(':')
    },
  },
  watch: {
    transactionTableType(newValue) {
      this.changeTransactionTabs(newValue)
    },
  },
  created() {
    this.changeTransactionTabs('transaction')
    this.getBalance()
    this.getCurrencies()
  },

  methods: {
    parseLocalizedJson(value) {
      if (!value) return {}
      if (typeof value === 'object') return value
      try {
        return JSON.parse(value)
      } catch (e) {
        return {}
      }
    },
    getCompanyIndustryLabel(company) {
      if (!company) return '-'

      const creditReformIndustry = this.parseLocalizedJson(
          company.credit_reform &&
          company.credit_reform[0] &&
          company.credit_reform[0].industry
            ? company.credit_reform[0].industry
            : null
      )

      const description = this.parseLocalizedJson(company.description)

      return (
          creditReformIndustry[this.appLanguage] ||
          description[this.appLanguage] ||
          creditReformIndustry.de ||
          creditReformIndustry.en ||
          description.de ||
          description.en ||
          '-'
      )
    },
    showReadInvoiceButton(item) {
      return 'Purchase' == item.type_description && !this.isSeller
    },

    isSuccessIcon(transaction) {
      const successTypes = [
        'Refund',
        'Deposit',
        'Completed',
        'ExchangeTo',
        'invoice_sold',
        'invoice_paid',
        'refund_defaults',
        'refund_not_defaults',
        'referral_program_reward'
      ];

      const isSuccessType = transaction ? successTypes.includes(transaction.type_description) : false;
      const isSellerPurchase = this.isSeller && transaction && transaction.type_description === 'Purchase';
      return isSuccessType || isSellerPurchase;
    },

    openCancelOptionModal(transaction) {
      this.remove_transaction = transaction
      this.cancel_option = true
      this.remove_transaction_fraction = this.remove_transaction.fraction.fraction
    },

    cancelOption() {
      this.$http.post(`/transactions/remove-option/${this.remove_transaction.id}`).then(response => {
        if (response.data.status === 200) {
          this.changeTransactionTabs('option_tab');

          const index = this.currencies.findIndex(
              currency => currency.id === this.remove_transaction.currency.id
          );

          this.changeTab(this.remove_transaction.currency.id,
              this.remove_transaction.currency.name, index);
        }
      })
    },

    renderTransactionReason(item) {
      if (!item) return '-'

      // We need to check if admin_transaction_reason or purpose of payment exists then show it
      const adminReason = this.getReason(item)
      if (adminReason) return adminReason

      const {invoice_id, type_description, fraction} = item
      const role = this.authUser.crole

      if (invoice_id && ['Purchase', 'Option'].includes(type_description)) {
        // When user is buyer and has fraction
        if (role === 'buyer' && fraction) {
          const label = type_description === 'Purchase' ? this.$t('purchased') : this.$t('Option')

          const fractionText = fraction.fraction ? `${fraction.fraction}% ` : ''

          return `<span>${label}</span> <span>${fractionText}</span> ${this.$t('of')} <span> I-${invoice_id}</span>`
        }

        return `I-${invoice_id}`
      }

      return '-'
    },

    getReason(transaction) {
      if (!transaction) return null

      let reason = null

      if (transaction.admin_transaction_reason) {
        try {
          const parsed = JSON.parse(transaction.admin_transaction_reason)
          const lang = this.$store.state.app.language
          reason = parsed?.[lang] || null
        } catch (err) {
          console.error('Invalid JSON in admin_transaction_reason:', err)
        }
      } else if (transaction.purpose_payment) {
        reason = transaction.purpose_payment
      }

      return reason
    },

    changeTransactionTabs(type) {
      switch (type) {
        case 'exchange':
          if (this.url === this.transaction_url) {
            this.refetch_data++;
          } else {
            this.url = this.transaction_url;
          }
          this.fields = this.isSeller
              ? this.transaction_fields_seller
              : this.transaction_fields;
          this.transactionTabIndex = 0;

          const index = this.currencies.findIndex(
              currency => currency.id === this.currencyTo.currencyTo
          );
          this.changeTab(this.currencyTo.currencyTo, this.currencies[index].name, index);
          break;

        case 'transaction':
          this.url = this.transaction_url;
          this.fields = this.isSeller
              ? this.transaction_fields_seller
              : this.transaction_fields;
          this.transactionTabIndex = 0;
          break;

        case 'option_tab':
          this.url = this.option_url;
          this.fields = this.option_fields;
          this.transactionTabIndex = 1;
          break;
      }
    },
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    changeTab(id, name, tabIndex) {
      this.currency.name = name
      this.currency.id = id
      this.tabIndex = tabIndex
      this.getBalance(id)
    },
    getCurrencies() {
      this.$http.post('/currency').then(response => {
        if (response.data.status === 200) {
          this.currencies = response.data.value
        }
      })
    },
    downloadPdf(item) {
      this.$http
          .post(`/invoice/fraction/download/${item.fraction_id}`, {}, {responseType: 'blob'})
          .then(response => {
            fileDownload(response.data, item.invoice.title)
          })
    },
    showModal(item) {
      const itemClone = structuredClone(item);
      if (itemClone.invoice) {
        itemClone.invoice.scoring = itemClone.invoice.scorings[0];
      }
      this.singleItem = itemClone;
      this.$bvModal.show('bv-modal-example')
    },
    readInvoice(item) {
      this.$http
          .post(`/invoice/fraction/read/${item.fraction_id}`, {
            responseType: 'json',
          })
          .then(response => {
            this.type = ''
            this.base64 = ''

            this.base64 = response.data.value.b64
            this.type = response.data.value.ext

            this.$store.commit('app/SET_FILE_TYPE', this.type)
            this.$store.commit('app/SET_FILE_BASE64', this.base64)

            window.open('/read-files', '_blank')
          })
          .catch(() => {
            this.isLoading = false
          })
    },
    getTransactions(id = 1) {
      if (this.payload?.currency_id === id) this.refetch_data++;

      const payload = {
        company_id: this.$store.state.auth.user.company_id,
        currency_id: id,
      };
      if (this.appliedStartDate) payload.start_date = this.appliedStartDate;
      if (this.appliedEndDate) payload.end_date = this.appliedEndDate;

      this.payload = payload;
    },

    applyTransactionDateFilter() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$bvToast.toast(this.$t('date_range_invalid'), {
          variant: 'warning',
          solid: true,
        });
        return;
      }
      this.appliedStartDate = this.startDate;
      this.appliedEndDate = this.endDate;
      this.getTransactions(this.currency.id);
    },

    downloadPdfReport() {
      const url = '/transactions/export/pdf';
      const payload = {company_id: this.authUser.company_id, startDate: this.startDate, endDate: this.endDate,currency_id: this.currency.id}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        fileDownload(response.data, this.$t('transaction_report_pdf'));
      });
    },

    downloadCsvReport() {
      const url = '/transactions/export/csv';
      const payload = {company_id: this.authUser.company_id, startDate: this.startDate, endDate: this.endDate,currency_id: this.currency.id}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        const filename = this.$t('transaction_report_csv');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(response.data, filename);
        } else {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(response.data);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    getBalance(id = 1) {
      // Cancel previous getBalance request if exists
      if (this.balanceCancelTokenSource) {
        this.balanceCancelTokenSource.cancel('New balance request initiated');
      }

      this.balanceCancelTokenSource = axios.CancelToken.source();

      this.loader = true;
      this.getTransactions(id);

      this.$http.post('/transactions/getBalance',
          {currency_id: id},
          {cancelToken: this.balanceCancelTokenSource.token}
      ).then(res => {
        if (typeof res.data.value !== 'undefined' && res.data.value) {
          this.data = res.data.value;
          this.balance = res.data.value;
        }
        this.loader = false;
        this.balanceCancelTokenSource = null;
      }).catch(error => {
        if (!axios.isCancel(error)) {
          this.loader = false;
        }
        this.balanceCancelTokenSource = null;
      });
    },
  },
  beforeDestroy() {
    if (this.balanceCancelTokenSource) {
      this.balanceCancelTokenSource.cancel('Component destroyed');
    }
  }
}
</script>
